//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 30/10/2025
// Version : 1
// Description : Es el Tab para la pantalla de desconexiones granel.
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date :
// Change by :
// Change description:
//
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import Navbar from "../../../Navbar";
import { logEventos } from "../../../../services/services";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import Desconexiones from "./Desconexiones";
import Desconexiones2 from '../desconexiones2/Desconexiones2';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  useEffect(() => {
    logEventos(
      "Acceso al menú Desconexiones Granel",
      "Desconexiones Granel",
      "Ver las desconexiones y motivos de desconexion ",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Tab_desconexiones() {
  const [activeTab, setActiveTab] = useState(0);
  const [showTabs, setShowTabs] = useState(true);

  return (
    <div>
      <Navbar />
      {showTabs ? (
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 1 }}>
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            aria-label="basic tabs example"
            centered
            variant="fullWidth"
          >
            <Tab label="Desconexiones" {...a11yProps(0)} />
            <Tab label="Movimiento de grúa" {...a11yProps(1)} />
          </Tabs>
        </Box>
      ) : null}
      <Desconexiones2 activeTab={activeTab} setShowTabs={setShowTabs} />
    </div>
  );
}

export default Tab_desconexiones;
